module.exports = __webpack_public_path__ + "img/7_133.703c057a.png";